import { FormattedMessage } from "react-intl";
import MainView from "views/MainView";
import { useState, useEffect } from "react";
import { userDeviceList, publicPath } from "request";
import { useLocation } from "react-router-dom";
import { useStoreContext } from "views/StoreContext";

import { ProductRow } from "./components";
import { Empty } from "components";
import { Skeleton } from "antd-mobile";

export const CompatibleDevice = () => {
  const location = useLocation();
  const { state: storeState, dispatch } = useStoreContext();

  const { state } = location;
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onGetProductList = () => {
    setIsLoading(true);

    if (state !== null && "lang" in state && "token" in state) {
    userDeviceList({ lang: state.lang, token: state.token })
      .then((response: any) => {
        setIsLoading(false);
        if (response?.code === "200") {
          dispatch({ type: "SAVE_PRODUCTS", payload: response.result });
        }
      })
      .catch((err: any) => {
        setIsLoading(false);
        console.log(err);
      });
    }
  };

  const SkeletonItem = () => {
    const logoStyle = {
      "--width": "54px",
      "--height": "54px",
      "--border-radius": "8px",
    };

    const titleStyle = {
      "--width": "50%",
      "--border-radius": "2px",
    };

    return (
      <div className="bg-white dark:bg-gray323434 rounded px-4 py-4 flex flex-row items-center mt-3">
        <div>
          <Skeleton animated style={logoStyle} />
        </div>
        <div className="w-full flex flex-col gap-4 px-3 flex-1">
          <div className="flex flex-col gap-2">
            <Skeleton
              animated
              style={{ ...titleStyle, "--height": "32px", "--width": "30%" }}
            />
            <Skeleton animated style={{ ...titleStyle, "--height": "16px" }} />
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (storeState.products.length > 0) {
      return;
    }
    onGetProductList();
  }, [state]);

  return (
    <MainView backgroundClassName="bg-page dark:bg-black1b1f1e pt-3">
      <div className="bg-white dark:bg-gray323434 pt-3 px-5 relative">
        <p className="text-lg font-medium">
          <FormattedMessage id="thirdParty.command.title" />
        </p>
        <span className="text-xs text-gray999 mt-2">
          <FormattedMessage id="thirdParty.command.tips" />
        </span>
        <div className="text-lg font-medium mt-8 pb-[1px] flex justify-start">
          <div className="flex items-center justify-center flex-col gap-1">
            <FormattedMessage id="thirdParty.command.device" />
            <div className="w-6 h-[1px] bg-primary rounded mb-1"></div>
          </div>
        </div>
        <img
          src={`${publicPath}/icons/voice-bg.png`}
          className="absolute w-[60px] right-[20px] bottom-[1px] z-[2]"
          alt=""
        />
      </div>

      {isLoading ? (
        <SkeletonItem />
      ) : (
        <>
          {(!storeState.products || storeState.products.length === 0) && (
            <Empty
              emptyText={<FormattedMessage id="thirdParty.data.empty.text" />}
            />
          )}

          <div className="overflow-y-auto pb-4">
            {storeState.products &&
              storeState.products.length > 0 &&
              storeState.products.map((product, key) => (
                <ProductRow
                  product={product}
                  key={key}
                  isVoiceProduct
                  isAllowClick
                />
              ))}
          </div>
        </>
      )}

      {/* 
      {isLoading && (
        <Spinner
          extraSmall
          className={{ "mt-12": true, "border-gray999": true }}
        />
      )}

      <div className="overflow-y-auto pb-4">
        {storeState.products &&
          storeState.products.length > 0 &&
          storeState.products.map((product, key) => (
            <ProductRow
              product={product}
              key={key}
              isVoiceProduct
              isAllowClick
            />
          ))}
      </div> */}
    </MainView>
  );
};
